import getPathName from 'features/tealium/getPathName';
import queueUtagCall from 'features/tealium/queueUtagCall';
import decodeHtml from 'utilities/decodeHtml';

function utagLinkProductImpressions (params) {

	if (params && typeof params === 'object') {

		queueUtagCall(() => {

			const decodedNames = params.product_impression_name
				? [ ...params.product_impression_name.map((val) => decodeHtml(val)) ]
				: [];

			const utagLinkParams = {
				event_name: 'view_item_list',
				event_noninteraction: 'true',
				product_sku: params.product_impression_sku || [],
				product_name: decodedNames,
				product_price: params.product_impression_price || [],
				product_index: params.product_impression_position || [],
				product_category: params.primaryCategory || [],
				product_grouping: params.product_grouping || [],
				product_quantity: 1,
				item_list_id: [],
				item_list_name: [ getPathName() ],
				sku_input_type: params.sku_input_type || []
			};

			window.utag.link(utagLinkParams);

		});

	}

}

export default utagLinkProductImpressions;
